import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { ItemModule } from '../../appshared/invoice/item/item.module';
import { ItemService } from '../../appshared/invoice/item/item.service';
import { environment } from '../../../environments/environment';
import { ItemPictureModule } from '../../appshared/invoice/item-picture/item-picture.module';
import { ItemPictureService } from '../../appshared/invoice/item-picture/item-picture.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CartService } from '../../appshared/invoice/cart.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-newarrived',
  standalone: true,
  imports: [CommonModule, TranslateModule, FontAwesomeModule, RouterLink],
  templateUrl: './newarrived.component.html',
  styleUrls: ['./newarrived.component.css'],
})
export class NewarrivedComponent implements OnInit {
  products: ItemModule[] = [];
  faShoppingCart = faShoppingCart;
  currentLang: string = localStorage.getItem('locale') || 'en';
  ComID: number = 1;
  apiURL: string =
    environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/Items/';
  categoryId!: number;
  totalItems: number = 1;

  constructor(
    private itemService: ItemService,
    private itemPictureService: ItemPictureService,
    private route: ActivatedRoute,
    private cartService: CartService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.categoryId = +params['categoryId'];
      this.fetchNewArrivals();
      this.fetchItemsByCategory();
    });
  }

  fetchNewArrivals(): void {
    this.itemService.getServiceNewArrival(1).subscribe(
      (response) => {
        this.products = response;
        this.products.forEach((product) => {
          this.fetchItemPictures(product.inItemID);
        });
      },
      (error) => {
        // console.error('Error fetching new arrivals:', error);
      }
    );
  }

  fetchItemsByCategory(): void {
    this.itemService
      .getServiceCategory(1, this.categoryId, 'Default')
      .subscribe(
        (products) => {
          this.products = products;
        },
        (error) => {
          // console.error('Error fetching items:', error);
        }
      );
  }

  fetchItemPictures(itemId: number): void {
    this.itemPictureService.getServiceID(itemId).subscribe(
      (pictures) => {
        const productPicture = pictures[0];
        const product: any = this.products.find(
          (prod) => prod.inItemID === itemId
        );
        if (product && productPicture) {
          product['imagePath'] = this.apiURL + productPicture.path;
        }
      },
      (error) => {
        // console.error(`Error fetching pictures for item ID ${itemId}:`, error);
      }
    );
  }

  addToCart(product: ItemModule): void {
    if (product) {
      const discountedPrice = this.calculateDiscountedPrice(product);
      const cartItem = {
        ...product,
        salesPrice: discountedPrice,
        cartQuantity: this.totalItems,
      };

      this.cartService.addToCart(cartItem, this.totalItems);
      if (this.currentLang === 'en') {
        this.toastr.success(`Added item ${product.name} to the cart.`);
      } else {
        this.toastr.success(`تمت إضافة ${product.name} إلى السلة.`);
      }

    } else {
      if (this.currentLang === 'en') {
        this.toastr.error('Error adding item to the cart.');
      } else {
        this.toastr.error('خطأ في إضافة المنتج إلى السلة.');
      }
    }
  }

  calculateDiscountedPrice(product: ItemModule): number {
    const discount = product.webDiscountAmount || 0;
    return product.salesPrice || 0 - discount;
  }
}
